<template>
  <div class="clearfix main_center">
    <div class="right-content clearfix busWinessRight">
      <el-card class="box-card" style="margin-bottom: 10px">
        <div slot="header" class="clearfix">
          <span>基本信息</span>
        </div>
        <el-form label-width="200px">
          <el-row>
            <el-col v-for="(item, ind) of basicList" :key="ind" :span="item.span || 12">
              <el-form-item :label="item.label">
                <span>{{ item.formatter ? item.formatter(detail[item.dataIndex]) : detail[item.dataIndex] }} {{ item.unit }}</span>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </el-card>

      <el-card class="box-card" style="margin-bottom: 10px">
        <div slot="header" class="clearfix">
          <span>评审专家支付明细</span>
        </div>
        <el-table :data="detail.detailList || []" stripe border style="width: 100%">
          <el-table-column type="index" header-align="center" align="center" label="序号" width="80"> </el-table-column>
          <el-table-column prop="expertName" align="left" :show-overflow-tooltip="true" min-width="120" label="专家姓名"></el-table-column>
          <el-table-column prop="certcode" align="left" :show-overflow-tooltip="true" min-width="180" label="身份证号码"></el-table-column>
          <el-table-column prop="phone" align="center" width="150" label="联系电话"></el-table-column>
          <el-table-column prop="payAmount" align="right" width="150" label="支付专家费金额(元)"></el-table-column>
          <el-table-column prop="taxAmount" align="right" width="130" label="个税金额(元)"></el-table-column>
          <el-table-column prop="invoiceAmount" align="right" width="130" label="开票金额(元)"></el-table-column>
          <el-table-column prop="trafficFee" align="right" width="140" label="交通包干费(元)"></el-table-column>
          <el-table-column prop="payState" align="center" width="100" label="支付状态">
            <template slot-scope="scope">
              <el-tag :type="scope.row.payState == '3' ? 'success' : 'warning'">
                {{ scope.row.payState == "3" ? "已支付" : "待支付" }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="payTime" align="center" width="170" label="支付时间"></el-table-column>
        </el-table>
      </el-card>
    </div>

    <div class="left-content busWinessLeft">
      <div class="left-navbar">
        <div class="left-navbar">
          <el-button @click="goBack()" size="small">返回</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { tabsCloseCurrentHandle } from "@/utils/routeTab";
export default {
  name: "EvaluationExpertpay_detail",
  components: {},
  data() {
    return {
      detail: {
        detailList: [],
      },
      id: "",
      basicList: [
        { label: "招标项目名称：", dataIndex: "buyprojectName", span: 24 },
        { label: "招标项目编号：", dataIndex: "buyprojectCode" },
        { label: "相关标段编号：", dataIndex: "sectionNums" },
        { label: "相关标段名称：", dataIndex: "sectionNames", span: 24 },
        { label: "评委到场时间：", dataIndex: "arriveTime" },
        { label: "评审结束时间：", dataIndex: "evalEndTime" },
        { label: "项目所在地：", dataIndex: "regionName" },
        { label: "招标人名称：", dataIndex: "tendererName" },
        { label: "招标人代码：", dataIndex: "tendererCode" },
        { label: "应税发生地：", dataIndex: "taxPlaceName" },
        { label: "联系人：", dataIndex: "contactMan" },
        { label: "联系方式：", dataIndex: "contactPhone" },
        { label: "电子邮箱：", dataIndex: "email" },
        { label: "备注：", dataIndex: "remark", span: 24 },
      ],
    };
  },
  methods: {
    getDetail() {
      this.$http.get(`/evaluationexpertpay/get?id=${this.id}`).then((res) => {
        const { code, data } = res.data;
        if (code == 1) {
          if (!data.detailList) {
            data.detailList = [];
          }
          this.detail = data;
        }
      });
    },
    goBack() {
      tabsCloseCurrentHandle();
      this.$router.push({
        path: `/evaluationExpertpay/expertpayList`,
      });
    },
  },
  created() {
    this.id = this.$route.query.id;
    this.getDetail();
  },
};
</script>
<style lang="less" scoped>
.el-form /deep/ .el-form-item.double-row {
  width: 50%;
}
.el-form /deep/ .el-form-item {
  margin-bottom: 0;
}
.right-content.busWinessRight {
  width: calc(100% - 160px);
}

.left-content.busWinessLeft {
  .left-navbar {
    width: 150px;
    border: none;
  }
}
</style>
